export const isBranch = (fullBranchName?: string): boolean => {
  return !!fullBranchName?.startsWith("refs/heads");
};
